<template>
  <div class="config-menu">
    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <div v-on="on" class="socket-status">
          <v-progress-circular
            :color="(socketInfo.isOnline ? 'green' : 'amber')"
            :value="100"
            class="ml-1"
            :size="9"
          ></v-progress-circular>
          <v-progress-circular
            :indeterminate="(!socketInfo.isConnected)"
            :color="(socketInfo.isConnected ? 'green' : 'amber')"
            :value="(socketInfo.isConnected ? 100 : 0)"
            class="ml-1"
            :size="9"
          ></v-progress-circular>
          <v-progress-circular
            :indeterminate="(!socketInfo.isLogged)"
            :color="(socketInfo.isLogged ? 'green' : 'amber')"
            :value="(socketInfo.isLogged ? 100 : 0)"
            class="ml-1"
            :size="9"
          ></v-progress-circular>
        </div>
      </template>
      <span v-html="`${(socketInfo.isOnline ? lang.app.online : lang.app.offline)} <br /> ${(socketInfo.isConnected ? lang.app.connected : lang.app.disconnected)} <br /> ${(socketInfo.isLogged ? lang.login.logged_user : lang.login.offline_user)}`"></span>
    </v-tooltip>
    <v-menu
      v-model="configMenu"
      :close-on-content-click="false"
      :nudge-width="200"
      offset-x
      class="config-menu-btn"
      content-class="config-menu-content"
    >
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on" medium class="config-menu-btn">
          <v-icon medium>mdi-cogs</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-list class="user-data mb-1">
          <Avatar />
        </v-list>
        <v-divider></v-divider>
        <v-list dense class="config-menu-list">
          <v-list-item link @click="fullDataReload()">
            <v-list-item-action class="position-relative">
              <v-icon>mdi-refresh</v-icon>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-progress-circular
                    v-on="on"
                    color="green"
                    value="100"
                    :size="9"
                    class="top-left-info"
                  ></v-progress-circular>
                </template>
                <span>
                  {{ lang.app.auto_updates_on }}
                </span>
              </v-tooltip>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ lang.app.force_reload }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <!-- <v-list-item link @click="lightdark = !lightdark">
            <v-list-item-action>
              <v-icon>{{ ($vuetify.theme.dark ? 'mdi-lightbulb-outline' : 'mdi-lightbulb-on-outline') }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ (!$vuetify.theme.dark ? lang.theme.light : lang.theme.dark) }}
                <v-switch
                  v-model="lightdark"
                  @click.native.stop
                  class="item-switch lightdark"
                ></v-switch>
                </v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->
          <v-list-item link @click="sound_alerts = !sound_alerts">
            <v-list-item-action>
              <v-icon>{{ (sound_alerts ? 'mdi-volume-high' : 'mdi-volume-variant-off') }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ lang.config.menu.sound_alerts }}
                <v-switch
                  v-model="sound_alerts"
                  @click.native.stop
                  class="item-switch"
                ></v-switch>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <router-link
            link
            :to="{ name: 'config' }"
            tag="div"
            exact
          >
            <v-list-item link>
              <v-list-item-action>
                <v-icon>mdi-cogs</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ lang.meta.pages.config.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          <v-list-item link @click="userLogout">
            <v-list-item-action>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ lang.login.logout }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import Avatar from '../components/Avatar'

import appdata from '@/mixins/appdata'

export default {
  mixins: [ appdata ],
  components: { Avatar },
  data: () => ({
    configMenu: false
  }),
  computed: {
    lightdark: {
      get: function () {
        return !this.$vuetify.theme.dark
      },
      set: function (newValue) {
        this.$vuetify.theme.dark = !newValue
        this.$vuetify.theme.light = newValue
        this.$store.dispatch('setTheme', { dark: this.$vuetify.theme.dark, light: this.$vuetify.theme.light })
      }
    },
    sound_alerts: {
      get: function () {
        if (typeof this.login_data.preferences.sound !== 'undefined') {
          return this.login_data.preferences.sound
        }
        return false
      },
      set: function (newValue) {
        this.$store.dispatch('setPreferences', { sound: newValue })
      }
    },
    isOnline () {
      return window.navigator.onLine
    }
  },
  methods: {
    userLogout () {
      this.$store.dispatch('setOverlay', true)
      this.$dialog.confirm({
        text: this.lang.login.confirmLogout,
        title: this.lang.confirm.title,
        waitForResult: true
      }).then(res => {
        this.$store.dispatch('setOverlay', false)
        if (res) {
          this.$store.dispatch('userLogout')
        }
      })
    }
  }
}
</script>
